import { Component, ViewEncapsulation, OnInit, Input, OnDestroy, ChangeDetectorRef } from '@angular/core'
import { Subscription } from 'rxjs'
import { MatTableDataSource } from '@angular/material/table'
import { ResultadosService } from '../../core/service/resultados.service'
import { Resultados, ResDesplega } from '../../shared/modelos.model'
import { DespRes, DespResTexto, TextoLibre, RayosX } from './resultados.model'
import { MBService } from '../../core/service/msg_box.service'
import { ToolbarService, LinkService, ImageService, HtmlEditorService, RichTextEditorModule } from '@syncfusion/ej2-angular-richtexteditor'
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations'

import { UntypedFormBuilder, UntypedFormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgClass } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-despliegaresultados',
    templateUrl: './despliegaresultados.component.html',
    styleUrls: ['./despliegaresultados.component.css'],
    providers: [ToolbarService, LinkService, ImageService, HtmlEditorService],
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, ReactiveFormsModule, NgClass, RichTextEditorModule, MatProgressSpinner, MatButton]
})
export class DespliegaresultadosComponent implements OnInit, OnDestroy {
  public tools: ToolbarModule = {
    type: 'MultiRow',
    items: ['Print', '|', 'Undo', 'Redo']
  }

  displayedColumns: string[] = [
    'Estudio',
    'Resultado',
    'Unidades',
    'Referencia'
  ]
  dataSource: MatTableDataSource<ResDesplega>
  NEst: string
  NombreEstudio
  resultados: ResDesplega[]
  ResFechas: Resultados[]
  despRes: DespRes[]
  despResTexto: DespResTexto[]
  despResRX: RayosX[]
  document: Document
  textolibre: TextoLibre[]
  form: UntypedFormGroup;
  indice: number[] = [0, 1, 2, 3, 4]
  isTblLoading = false
  private subs = new Subscription();
  private cdr: ChangeDetectorRef;

  @Input() set inputPacID(val: string) {
    if (val) {
      this.DespliegaResultados(val);
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  constructor(
    private resultadosServices: ResultadosService,
    private msgBox: MBService,
    private _formBuilder: UntypedFormBuilder,
    cdr: ChangeDetectorRef
  ) {
    this.cdr = cdr;
    this.form = this._formBuilder.group({
      reporte: [''],
      resultado: ['']
    });
  }

  ngOnInit(): void {
    // Ya inicializado en el constructor
  }

  DespliegaResultados(PacID: string): void {
    this.isTblLoading = true;
    console.log('Iniciando peticion para PacID:', PacID);
    this.subs.add(
      this.resultadosServices.GetResultadosPaciente(PacID).subscribe({
        next: (res) => {
          this.isTblLoading = false;
          console.log('Respuesta del servidor:', res);
          const { laboratorio, texto, rayosx } = res;

          if (
            (!laboratorio || laboratorio.length === 0) &&
            (!texto || texto.length === 0) &&
            (!rayosx || rayosx.length === 0)
          ) {
            console.log('Sin resultados');
            this.msgBox.Notificar(
              'Sin Estudios de Laboratorio  ó   Estudios en Proceso'
            );
            this.cdr.detectChanges();
            return;
          }

          this.despRes = laboratorio ?? [];
          console.log('despRes asignado:', this.despRes);
          this.despResTexto = texto ?? [];
          this.despResRX = rayosx ?? [];

          // Inicializar el formulario con el primer reporte de texto/RX si existe
          if (texto && texto.length > 0) {
            this.form = this._formBuilder.group({
              reporte: [texto[0].ResWb],
              resultado: [rayosx && rayosx.length > 0 ? rayosx[0].ResRx : '']
            });
          }

          this.cdr.detectChanges();
        },
        error: (err) => {
          this.isTblLoading = false;
          this.msgBox.OcurrioError(err.error);
          this.cdr.detectChanges();
        }
      })
    );
  }

  traeResultados(PacID: string, EstID: string, NomEst: string): void {
    this.subs.add(this.resultadosServices.getResultados(PacID, EstID).subscribe({
      next: (res) => {
        // console.log(res);
        this.ResFechas = res
        this.resultados = []
        let consecutivo = 0
        let result
        if (this.ResFechas.length > 1) {
          consecutivo = consecutivo + 1
          this.resultados.push({
            id: consecutivo,
            Estudio: NomEst,
            Resultado: '',
            Unidades: '',
            Referencia: ''
          })
          for (const elemento of this.ResFechas) {
            consecutivo = consecutivo + 1
            if (elemento.ResLista.length > 0) {
              result = elemento.ResLista
            } else if (elemento.ResTexto.length > 1) {
              result = elemento.ResTexto
            } else if (elemento.ResNum !== '-999999') {
              result = elemento.ResNum
            }
            this.resultados.push({
              id: consecutivo,
              Estudio: '     ' + elemento.Componente,
              Resultado: result,
              Unidades: elemento.Unidades,
              Referencia: elemento.Referencia
            })
          }
        } else {
          for (const elemento of this.ResFechas) {
            consecutivo = consecutivo + 1
            if (elemento.ResLista.length > 0) {
              result = elemento.ResLista
            } else if (elemento.ResTexto.length > 1) {
              result = elemento.ResTexto
            } else if (elemento.ResNum !== '-999999') {
              result = elemento.ResNum
            }
            this.resultados.push({
              id: consecutivo,
              Estudio: NomEst,
              Resultado: result,
              Unidades: elemento.Unidades,
              Referencia: elemento.Referencia
            })
          }
        }
        this.dataSource = new MatTableDataSource(this.resultados)
        // console.log(this.resultados);
      },
      error: (err) => this.msgBox.OcurrioError(err.error)
    }))
  }

  formatResultado(resultado: any, referencia: string): string {
    if (resultado === undefined || resultado === null) return '';
    const resStr = resultado.toString().trim();
    if (!referencia) return resStr;

    // Check if resultado is a valid number
    const resVal = parseFloat(resStr.replace(/,/g, ''));
    if (isNaN(resVal) || resStr.match(/[a-zA-Z]/)) {
      // If it contains letters (like 'Positivo') or isn't a number, return as is
      return resStr;
    }

    // Find all decimal parts in the reference string (e.g. "4.00 - 10.00" -> ".00", ".00")
    const decMatches = referencia.match(/\.\d+/g);
    if (decMatches && decMatches.length > 0) {
      // Find the maximum number of decimal places used in the reference
      let maxDecimals = 0;
      for (const match of decMatches) {
        const decLength = match.length - 1; // subtract 1 for the dot
        if (decLength > maxDecimals) maxDecimals = decLength;
      }
      
      // Format the result to match the maximum decimal places
      return resVal.toFixed(maxDecimals);
    }

    return resStr;
  }

  esAnormal(resultado: any, referencia: string): boolean {
    if (resultado === undefined || resultado === null || !referencia) return false;
    
    const resStr = resultado.toString().trim();
    const refStr = referencia.toString().trim();

    // Check for Negative/Positive mismatches
    if (refStr.toLowerCase().includes('negativo') && resStr.toLowerCase().includes('positivo')) {
      return true;
    }

    // Try parsing as numbers
    const resVal = parseFloat(resStr.replace(/,/g, ''));
    if (isNaN(resVal)) return false;

    // Range like "0.72 - 1.23"
    const rangeMatch = refStr.match(/([0-9.]+)\s*-\s*([0-9.]+)/);
    if (rangeMatch) {
      const min = parseFloat(rangeMatch[1]);
      const max = parseFloat(rangeMatch[2]);
      if (resVal < min || resVal > max) {
        return true;
      }
      return false;
    }

    // Less than like "< 5.0"
    const ltMatch = refStr.match(/<\s*([0-9.]+)/);
    if (ltMatch) {
      if (resVal >= parseFloat(ltMatch[1])) return true;
      return false;
    }

    // Greater than like "> 5.0"
    const gtMatch = refStr.match(/>\s*([0-9.]+)/);
    if (gtMatch) {
      if (resVal <= parseFloat(gtMatch[1])) return true;
      return false;
    }

    return false;
  }

  tieneTabla(tabla: any): boolean {
    // console.log(tabla)
    if (tabla !== undefined && tabla !== null) {
      if (tabla.length > 1) {
        // console.log(tabla.length)
        return true
      } else {
        return false
      }
    } else {
      return false;
    }
  }
}
